import { useBreak } from "hooks/useBreak"
import { MobileFooter } from "./MobileFooter"
import { DesktopFooter } from "./DesktopFooter"

export const MainFooter = () => {
  
  const isMobile = useBreak('md_dn')

  return isMobile ? <MobileFooter /> : <DesktopFooter />
}
